import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  initializeStepEulaFailed,
  initializeStepEulaSuccess
} from '../../../actions/workflows/steps/Eula';
import EulaStepAPI from '../../../api/workflows/steps/Eula';
import * as Constants from '../../../constants/action-constants';

function* initializeStepEula() {
  try {
    const eula = yield call(EulaStepAPI.getEula);
    yield put(initializeStepEulaSuccess(eula));
  } catch (e) {
    yield put(initializeStepEulaFailed());
  }
}

function* watchForEula() {
  yield takeLatest(Constants.INITIALIZE_STEP_EULA, initializeStepEula);
}

export default function* eulaSaga() {
  yield all([watchForEula()]);
}
